module.exports = __webpack_public_path__ + "static/media/Receipt_Template_1.2b7e118f.png";